// extracted by mini-css-extract-plugin
module.exports = {"support":"Support_support__1oLXb"};